module.exports = __webpack_public_path__ + "static/visual_1_1_dont-57467712204821931bc4d9e8fce5236e.png";